import React from 'react';
import * as XLSX from 'xlsx';

/** Form state, Excel template download and bulk-upload parsing for the create/edit store drawer. */
export function useCreateStoreDrawer({ clients, setOpen, isEdit, store, setStore }) {
    const [name, setName] = React.useState('');
    const [rif, setRif] = React.useState('');
    const [client, setClient] = React.useState('');
    const [filteredClients, setFilteredClients] = React.useState([]);
    const [channel, setChannel] = React.useState('moderno');
    const [storeType, setStoreType] = React.useState('');
    const [hasWarehouse, setHasWarehouse] = React.useState(false);
    const [stores, setStores] = React.useState([]);
    const [massiveClient, setMassiveClient] = React.useState('');

    React.useEffect(() => {
        if (isEdit) {
            const clientChannel = clients ? clients?.find((c) => c._id === store?.client)?.channel : '';
            setName(store?.name ?? '');
            setRif(store?.rif ?? '');
            setChannel(clientChannel ?? '');
            setStoreType(store?.storeType ?? '');
            setHasWarehouse(store?.hasWarehouse ?? false);
            setClient(store?.client ?? '');
        } else {
            setName('');
            setRif('');
            setChannel('');
            setStoreType('');
            setHasWarehouse(false);
            setClient('');
        }
    }, [setOpen, store, isEdit, clients]);

    const handleChannel = (e) => {
        setChannel(e);
        setClient('');
        if (e === 'moderno' && clients) {
            setFilteredClients(clients?.filter((c) => c?.channel === 'moderno'));
        } else {
            setFilteredClients(clients?.filter((c) => c?.channel === 'tradicional'));
        }
    };

    React.useEffect(() => {
        if (channel === 'moderno' && clients) {
            setFilteredClients(clients?.filter((c) => c?.channel === 'moderno'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clients]);

    const onCloseDrawer = () => {
        setName('');
        setRif('');
        setChannel('');
        setStoreType('');
        setHasWarehouse(false);
        setClient('');
        setStore(null);
        setOpen(false);
    };

    const handleClient = (e) => {
        setClient(e);
    };

    const downloadExcel = () => {
        const list = [{ nombre: '', rif: '', tipo_de_piso: 'nacional', almacen: 'TRUE' }];

        const ws = XLSX.utils.json_to_sheet(list);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Carga Masiva Pisos de Venta');
        XLSX.writeFile(wb, 'carga_masiva_pisos_de_venta.xlsx');
    };

    const LoadExcelData = (file) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = e.target?.result;
            const workbook = XLSX.read(data, { type: 'binary' });
            const sheet_name_list = workbook.SheetNames;
            const xlData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet_name_list[0]]);
            await Promise.all(
                xlData?.map(async (st) => {
                    const hasWarehouse = st?.almacen?.toString().toLowerCase() === 'true' ? true : false;
                    const storeType = st?.tipo_de_piso;
                    return {
                        name: st?.nombre,
                        rif: st?.rif,
                        client: massiveClient,
                        clientName: massiveClient === '' ? clients[0]?.name : clients?.find((c) => c._id === massiveClient)?.name,
                        storeType: storeType,
                        hasWarehouse,
                        active: true
                    };
                })
            ).then((data) => {
                setStores(data);
            });
        };
        reader.readAsBinaryString(file.originFileObj);
    };

    // Clients offered for the selected channel (all clients until a channel is picked).
    const channelClients = channel ? clients?.filter((c) => c?.channel === channel) : clients;

    return {
        name,
        setName,
        rif,
        setRif,
        client,
        filteredClients,
        channel,
        storeType,
        setStoreType,
        hasWarehouse,
        setHasWarehouse,
        stores,
        setMassiveClient,
        channelClients,
        handleChannel,
        handleClient,
        onCloseDrawer,
        downloadExcel,
        LoadExcelData
    };
}
